// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-selector[data-v-1b0a1010] {width:100%;max-width:90px}.per-page-selector[data-v-1b0a1010]  .vs__selected-options{-ms-flex-wrap:nowrap;flex-wrap:nowrap}", ""]);
// Exports
module.exports = exports;
